module.exports = __webpack_public_path__ + "assets/img/33s.41e2be9c.png";